import React from "react";
import { Tooltip } from "@mui/material";
import { IoChevronDown } from "react-icons/io5";
import JGIcon from "../../JGIcon";
import * as S from "./ScrollIndicator.styles";
import { useEffectOnce, useMeasure } from "react-use";

const ScrollIndicator = () => {
  const [chatlioRef, chatlioSize] = useMeasure();

  const updateChatlioRef = () => {
    const widgetEl = document.getElementsByClassName("chatlio-widget")?.[0];
    if (widgetEl) {
      chatlioRef(widgetEl);
    }
  };

  useEffectOnce(() => {
    /**
     * Attempt to update the ref right away. On initial website load, this likely won't be ready yet, but
     * thereafter, it should be ready and `"chatlio.ready"` will have already been called before we get here.
     */
    updateChatlioRef();

    document.addEventListener("chatlio.ready", updateChatlioRef);

    return () => {
      document.removeEventListener("chatlio.ready", updateChatlioRef);
    };
  });

  return (
    <Tooltip title="Scroll down" placement="top">
      <S.Container
        className="jg-home-image-gallery__scroll-indicator"
        sx={theme => ({
          right: chatlioSize?.width || 0,
          bottom: `calc(
            ${chatlioSize?.height ? `${(chatlioSize.height / 2)}px` : theme.spacing(5)}
            + var(--jg-home-image-gallery-border-radius)
          )`,
        })}
      >
        <JGIcon is={IoChevronDown} />
      </S.Container>
    </Tooltip>
  );
};

export default ScrollIndicator;
